// extracted by mini-css-extract-plugin
export default {"table_wrap":"paymentDetailsOrder_table_wrap__A2Df+","sent_btn":"paymentDetailsOrder_sent_btn__+Pdci"};